import React, { useEffect } from "react";
import { DataGrid, deDE, GridColDef, GridRowParams, GridSortModel, LocalizationV4 } from "@material-ui/data-grid";
import PropTypes from 'prop-types'
//import Tooltip from '@material-ui/core/Tooltip';
import Grid from "@material-ui/core/Grid";
import {
  Button,
  Container,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";

import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import {
  setEditEntry,
  setError,
  resetError,
  setFaktor,
  setKommentar,
  getWandlerListe,
  selectEditEntry,
  selectViewMode,
  selectNewEntry,
  selectWandlerListe,
  selectAktuellerWandler,
  selectEditDirty,
  selectError,
  wandlerDummy,
  updateAktuellerWandler,
  startNewEntry,
  createWandler,
  updateWandler,
  deleteWandler,
  discardNew,
  discardChanges,
  selectListLoading,
  selectSorting,
  setSorting,
  resetViewMode
} from "./wandlerSlice";

import { useStyles } from "./../wertelisteStyles";
import { useMsal } from "@azure/msal-react";
import { wandler } from "../../../../utils/apiTypes";
import { rollen, isAuthorized } from "../../../../utils/auth/authConfig";
import { validate, validateHelper } from "../../../../features/validate/validate";
import { globalStyles } from "../../../../assets/globalStyles";

export interface WandlerPropsType {
  wandlerTyp: string;
  deleteUrl: string; // because the InferProps props allows alows null value
  createUrl: string;
  updateUrl: string;
  getUrl: string;
}


export const WandlerPropsTypeReact = {
  wandlerTyp: PropTypes.string.isRequired,
  deleteUrl: PropTypes.string.isRequired,
  createUrl: PropTypes.string.isRequired,
  updateUrl: PropTypes.string.isRequired,
  getUrl: PropTypes.string.isRequired,
}



const Wandler: React.FC<WandlerPropsType> = (props) => {
  const { wandlerTyp, deleteUrl, createUrl, updateUrl, getUrl } = props
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const rollenObj = rollen;

  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

  useEffect(() => {
    dispatch(getWandlerListe(getUrl, wandlerTyp))
  }, [instance]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const
    WandlerSelectListe: wandler[] = useAppSelector(selectWandlerListe),
    editEntry: boolean = useAppSelector(selectEditEntry),
    newEntry: boolean = useAppSelector(selectNewEntry),
    aktuellerWandler: wandler = useAppSelector(selectAktuellerWandler),
    viewMode: boolean = useAppSelector(selectViewMode),
    dirtyEdit: number = useAppSelector(selectEditDirty),
    inputError: boolean = useAppSelector(selectError),
    listLoading: boolean = useAppSelector(selectListLoading),
    sorting: GridSortModel = useAppSelector(selectSorting);

  const dataGridCols2: GridColDef[] = [
    { field: 'faktor', headerName: 'Faktor', flex: 2 },
  ]

  function printTableWandler(data: wandler[]) {
    return (
      <Container maxWidth={false} className={classes.root}>
        <div style={{ height: "50vh", width: '100%' }}>
          <DataGrid
            localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
            disableColumnMenu={false}
            disableColumnSelector={true}
            columns={dataGridCols2}
            getRowId={(row) => row.faktor}
            rows={data}
            sortModel={sorting}
            onSortModelChange={(model) => setSorting(model.sortModel)}
            onRowClick={(param: GridRowParams) => {
              let ws = wandlerDummy;
              const currentWs = data.find(w => w.faktor == (param.row.faktor))
              if (currentWs)
                ws = currentWs;
              if (!editEntry) dispatch(updateAktuellerWandler(ws));
            }}
            loading={listLoading} />
        </div>
      </Container>
    );
  }

  function printSaveDiscardButtons() {
    return (<div>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(createWandler(aktuellerWandler, createUrl, wandlerTyp)) : dispatch(updateWandler(aktuellerWandler, updateUrl, wandlerTyp)) }}
        color="secondary"
        className={classes.showtriButton}
        disabled={
          aktuellerWandler.faktor == ""
          || !dirtyEdit
          || inputError}
        style={{ minHeight: "36px" }}
      >
        {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
      </Button>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
        color="secondary"
        className={classes.showtriButton}
      >
        Abbrechen
      </Button>
    </div>)
  }
  function confirmDeleteOfRoutergeraet() {
    dispatch(deleteWandler(aktuellerWandler, deleteUrl));
    setOpenDeleteDialog(false);
  }

  function printEditDeleteButton() {
    if (isAuthorized([rollenObj.admin, rollenObj.betrieb]))
      return (
        <div>
          <Button
            variant="contained"
            onClick={() => dispatch(setEditEntry())}
            color="secondary"
            className={classes.showtriButton}
          >
            Bearbeiten
          </Button>
          {!aktuellerWandler.zugeordnet ?
          <Button
            variant="contained"
            onClick={() => setOpenDeleteDialog(true)}
            color="secondary"
            className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
          >
            {listLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
          </Button>
          : ""}
          <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
          >
            <DialogTitle>{wandlerTyp + 'wandler löschen'}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {'Sind Sie sicher, dass Sie das ' + wandlerTyp + 'wandler "' +
                  aktuellerWandler.faktor +
                  '" wirklich löschen wollen?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => setOpenDeleteDialog(false)}
                className={classes.cancleDeleteButton}
              >
                Abbrechen
              </Button>
              <Button
                color="secondary"
                variant="contained"
                onClick={confirmDeleteOfRoutergeraet}
                className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
              >
                Löschen
              </Button>
            </DialogActions>
          </Dialog>
          <Button
            variant="contained"
            onClick={() => { dispatch(resetViewMode()) }}
            color="default"
            className={classes.showtriButton}
          >
            Schließen
          </Button>
        </div>
      );
    else return (<React.Fragment />)
  }

  function printEdit() {
    return (
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }} >
        <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
          <div>
            <Grid container spacing={4}>
              <Grid item container xs={12}>
                <Grid item md={3} >
                  <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"}>
                    {newEntry ? "Neuen " + wandlerTyp + "wandler anlegen" : "Bearbeiten von " + wandlerTyp + "wandler: " + aktuellerWandler.faktor.toString()}
                  </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={6} >
                  {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={true}
                    id={wandlerTyp + "wandler-faktor"}
                    disabled={newEntry ? false : true}
                    label="Faktor"
                    error={validate(dispatch, setError, resetError, aktuellerWandler.faktor.toString(), "faktor")}
                    helperText={validateHelper(aktuellerWandler.faktor)}
                    variant="outlined"
                    onChange={(event) => dispatch(setFaktor(event.target.value))}
                    value={aktuellerWandler.faktor}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    disabled={editEntry ? false : true}
                    id={wandlerTyp + "wandler-kommentar"}
                    multiline
                    rows={4}
                    rowsMax={8}
                    label="Kommentar"
                    error={validate(dispatch, setError, resetError, aktuellerWandler.kommentar, "kommentar")}
                    helperText={validateHelper(aktuellerWandler.kommentar)}
                    variant="outlined"
                    onChange={(event) => dispatch(setKommentar(event.target.value))}
                    value={aktuellerWandler.kommentar ? aktuellerWandler.kommentar : ""}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    )
  }

  return (
    <div>
      {viewMode ? printEdit() : ""}
      <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
        <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "0px" }}>
          <Grid item md={3} >
            <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
              Stromwandler Übersicht
            </Typography>
          </Grid>
          <Grid item md={3} />
          <Grid item md={6} style={{ paddingRight: "24px", paddingTop: "0px" }}>
            <Grid item container md={12}>
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3}>
                {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                  <Button
                    variant="contained"
                    onClick={() => dispatch(startNewEntry())}
                    color="secondary"
                    className={classes.showButton}
                    disabled={editEntry ? true : false}
                  >
                    Hinzufügen
                  </Button>
                  : ""}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          {printTableWandler(WandlerSelectListe)}
        </Grid>
      </Paper>
    </div>
  );
}
Wandler.propTypes = WandlerPropsTypeReact
export default Wandler